import { ref, onMounted, onBeforeUnmount } from 'vue'

// options will be any IntersectionObserverInit

/**
 * Simple composable to track whether a DOM element (selected by CSS selector)
 * is currently intersecting the viewport according to the provided options.
 * Returns a ref `isInView` which is `true` when the element is intersecting.
 */
export function useVisibility(
  selector: string,
  options: IntersectionObserverInit = {}
) {
  const isInView = ref(false)
  let observer: IntersectionObserver | undefined

  onMounted(() => {
    if (typeof window === 'undefined' || !selector) return

    const el = document.querySelector(selector)
    if (!el) return

    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        isInView.value = entry.isIntersecting
      })
    }, options)

    observer.observe(el)
  })

  onBeforeUnmount(() => {
    if (observer) observer.disconnect()
  })

  return { isInView }
}

export default useVisibility
